export const DEVICES_COMMON_SEARCH_DEVICES = "DEVICES_COMMON_SEARCH_DEVICES";
export const DEVICES_COMMON_SEARCH_DEVICES_RESULT = "DEVICES_COMMON_SEARCH_DEVICES_RESULT";